var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1428 20.5045H5.85789C5.33594 20.5036 4.91305 20.0807 4.91211 19.5588V18.7916C4.91865 16.6085 6.6873 14.8406 8.87043 14.835H15.1303C17.3134 14.8406 19.082 16.6085 19.0886 18.7916V19.5588C19.0877 20.0807 18.6648 20.5036 18.1428 20.5045Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 3.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9992 11.1498C9.8874 11.1498 8.17469 9.43934 8.17188 7.32756C8.16908 5.21577 9.87725 3.50077 11.989 3.49513C14.1008 3.48952 15.8181 5.19539 15.8266 7.30716C15.8297 8.32461 15.428 9.30152 14.71 10.0224C13.9919 10.7433 13.0166 11.1489 11.9992 11.1498Z",
    fill: "#3158F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.248166b65a300facf16f94b0d5229850.svg";
export { ForwardRef as ReactComponent };